/**
 * Canonical colour values for the site.
 *
 * This is the single source of truth: `tailwind.config.js` requires this file
 * to build its colour scale, and TypeScript imports it wherever a colour has
 * to be handed to something that is not a class name -- a react-feather
 * `color=` prop, a MUI `sx` object, an inline SVG fill. Nothing else should
 * contain a hex literal.
 *
 * Before this existed the palette held two maroons (#481711, #461511), two
 * golds (#F2B84C, #F2B84F), two body greys (#595959, #5A5A5A) and five blues
 * that all meant "link" -- differences of two or three points that no one can
 * see but that make a colour impossible to search for. One value each now.
 */
const palette = {
  // Brand
  brand: '#461511',       // maroon: header, footer, headings, emphasis
  brandWarm: '#701811',   // surname-leader badge on a tree node
  brandAlert: '#A50C00',  // lineage-leader badge

  // Gold accents
  gold: '#F2B84C',        // primary accent: buttons, active nav, rules
  goldSoft: '#F9D876',
  goldPale: '#FFEAAE',    // tree person-node fill, calendar "today"
  goldWash: '#FFFBEE',    // page tint behind gold sections
  goldCream: '#FFEEBE',   // label text on the bronze clan node
  goldSand: '#EDC584',    // branch label on the tree
  goldBronze: '#B9752A',  // clan label on the tree
  goldDeep: '#D48900',    // active tab underline

  // Status
  danger: '#F03D3E',
  success: '#007B40',
  link: '#0031AF',

  // Neutrals
  ink: '#595959',         // body text
  inkSoft: '#7D7D7D',     // secondary text, disabled input text
  inkMute: '#B5B5B5',     // table headers, placeholder

  line: '#E1E1E1',        // input and card borders
  lineSoft: '#E5E5E5',
  lineStrong: '#D9D9D9',  // inactive filter chip

  surfaceSunken: '#F4F4F4', // page background
  surfaceMuted: '#F3F3F3',  // zebra striping
  white: '#FFFFFF',

  warning: '#D84910',       // warning toast
  scrollThumb: '#475467',   // custom scrollbar
};

module.exports = palette;
